import React from 'react';

import sanitary_condition_red from 'assets/images/vulnerability-icon/vulnerability_sanitary_condition_red.svg';
import sanitary_condition_orange from 'assets/images/vulnerability-icon/vulnerability_sanitary_condition_orange.svg';
import sanitary_condition_yellow from 'assets/images/vulnerability-icon/vulnerability_sanitary_condition_yellow.svg';
import sanitary_condition_light_gray from 'assets/images/vulnerability-icon/vulnerability_sanitary_condition_light_gray.svg';
import technical_condition_red from 'assets/images/vulnerability-icon/vulnerability_technical_condition_red.svg';
import technical_condition_orange from 'assets/images/vulnerability-icon/vulnerability_technical_condition_orange.svg';
import technical_condition_yellow from 'assets/images/vulnerability-icon/vulnerability_technical_condition_yellow.svg';
import technical_condition_light_gray from 'assets/images/vulnerability-icon/vulnerability_technical_condition_light_gray.svg';
import human_factor_red from 'assets/images/vulnerability-icon/vulnerability_human_factor_red.svg';
import human_factor_orange from 'assets/images/vulnerability-icon/vulnerability_human_factor_orange.svg';
import human_factor_yellow from 'assets/images/vulnerability-icon/vulnerability_human_factor_yellow.svg';
import human_factor_light_gray from 'assets/images/vulnerability-icon/vulnerability_human_factor_light_gray.svg';
import environmental_factor_red from 'assets/images/vulnerability-icon/vulnerability_environmental_condition_red.svg';
import environmental_factor_orange from 'assets/images/vulnerability-icon/vulnerability_environmental_condition_orange.svg';
import environmental_factor_yellow from 'assets/images/vulnerability-icon/vulnerability_environmental_condition_yellow.svg';
import environmental_factor_light_gray from 'assets/images/vulnerability-icon/vulnerability_environmental_condition_light_gray.svg';
import { CategoryValues, CriticalityValues } from 'pages/InteractiveMap/components/Modals/AddVulOnMap/types';

const CATEGORY_MAP: Record<string, string> = {
  [CategoryValues.SANITARY]: 'sanitary_condition',
  [CategoryValues.TECHNICAL]: 'technical_condition',
  [CategoryValues.STAFF]: 'human_factor',
  [CategoryValues.ENVIRONMENTAL]: 'environmental_condition',
};

const CRITICALITY_MAP: Record<string, string> = {
  [CriticalityValues.CRITICAL]: 'red',
  [CriticalityValues.HIGH]: 'orange',
  [CriticalityValues.MEDIUM]: 'yellow',
  [CriticalityValues.LOW]: 'light_gray',
};

const ICONS: Record<string, string> = {
  sanitary_condition_red: sanitary_condition_red,
  sanitary_condition_orange: sanitary_condition_orange,
  sanitary_condition_yellow: sanitary_condition_yellow,
  sanitary_condition_light_gray: sanitary_condition_light_gray,

  technical_condition_red: technical_condition_red,
  technical_condition_orange: technical_condition_orange,
  technical_condition_yellow: technical_condition_yellow,
  technical_condition_light_gray: technical_condition_light_gray,

  human_factor_red: human_factor_red,
  human_factor_orange: human_factor_orange,
  human_factor_yellow: human_factor_yellow,
  human_factor_light_gray: human_factor_light_gray,

  environmental_condition_red: environmental_factor_red,
  environmental_condition_orange: environmental_factor_orange,
  environmental_condition_yellow: environmental_factor_yellow,
  environmental_condition_light_gray: environmental_factor_light_gray,
};

interface VulSvgProps {
  category: string;
  criticality: string;
  size?: number;
  className?: string;
}

const VulSvg: React.FC<VulSvgProps> = ({ category, criticality, size = 38, className }) => {
  const cat = CATEGORY_MAP[category] || 'technical_condition';
  const crit = CRITICALITY_MAP[criticality] || 'light_gray';
  const key = `${cat}_${crit}`;
  const iconSrc = ICONS[key] || ICONS[`${cat}_light_gray`];
  if (!iconSrc) {
    return <div style={{ width: size, height: size, background: '#ccc', borderRadius: '50%' }} className={className} />;
  }
  return <img src={iconSrc} width={size} height={size} className={className} alt="vulnerability icon" />;
};

export default VulSvg;
